// extracted by mini-css-extract-plugin
export default {"imageContainer":"bfa-z","summaryPar":"cfa-z","ratingCategories":"dfa-z","reviewerInfo":"efa-z","reviewTypes":"ffa-z","expanded":"gfa-z"};